import * as types from './constants';

// eslint-disable-next-line import/no-anonymous-default-export
export default  function (state = {}, action) {

    switch (action.type) {
        case types.SET_COUNTRIES_RULES: {
            return { ...state, ...action.countryrules };
        }
        default: {
            return state;
        }
    }
}

